import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardGroupActions } from './actions/card-group.actions';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [ CardGroupActions ]
})
export class CardGroupModule { }
